import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import { SagaIterator } from '@redux-saga/core';
// import { APICore, AUTH_SESSION_KEY, setAuthorization } from 'helpers/api/apiCore';
import { getProducts as getProductsApi, addProduct as addProductApi } from 'helpers';
import { productApiResponseSuccess, productApiResponseError } from './actions';
import { ProductActionTypes } from './constants';
import { deleteProductByIdApi, getProductDetails, updateProductDetails, uploadImageApi } from 'helpers/api/products';

// type UserData = {
//     payload: {
//         username: string;
//         firstname: string;
//         lastname: string;
//         companyName: string;
//         email: string;
//         password: string;
//         baseCurrency: string;
//     };
//     type: string;
// };

// const api = new APICore();

/**
 * Login the user
 * @param {*} payload - username and password
 */
function* getProducts({ payload: { limit, page, customerId, category, sortBy, sortType, search } }: any): SagaIterator {
    try {
        const response = yield call(getProductsApi, { limit, page, customerId, category, sortBy, sortType, search });
        // Pass full response so reducer gets totalResults, totalPages, currentPage
        yield put(productApiResponseSuccess(ProductActionTypes.GET_PRODUCTS, response.data));
    } catch (error: any) {
        console.log('coming here err', error);
        yield put(productApiResponseError(ProductActionTypes.GET_PRODUCTS, error));
    }
}

function* addProduct({ payload: { productDetails } }: any): SagaIterator {
    try {
        console.log('productDetails', productDetails);
        const response = yield call(addProductApi, { ...productDetails });
        const createdProduct = response?.data;
        yield put(productApiResponseSuccess(ProductActionTypes.ADD_PRODUCT, createdProduct));
    } catch (error: any) {
        console.log('coming here err', error);
        yield put(productApiResponseError(ProductActionTypes.ADD_PRODUCT, error));
    }
}
function* uploadImage(payload: any): SagaIterator {
    try {
        console.log(payload)
        const response = yield call(uploadImageApi, { file: payload.file });
        const createdProduct = response?.data;
        yield put(productApiResponseSuccess(ProductActionTypes.UPLOAD_IMAGE, createdProduct));
    } catch (error: any) {
        console.log('coming here err', error);
        yield put(productApiResponseError(ProductActionTypes.UPLOAD_IMAGE, error));
    }
}

function* getProductDetailsByIdSaga(action: any): SagaIterator {
    try {
        console.log(action)
        const response = yield call(getProductDetails, action.payload);
        const productDetails = response.data;
        yield put(productApiResponseSuccess(ProductActionTypes.GET_PRODUCT_DETAILS, productDetails));
    } catch (error: any) {
        yield put(productApiResponseError(ProductActionTypes.GET_PRODUCT_DETAILS, error));
    }
}
function* updateProductByIdSaga(action: any): SagaIterator {
    try {
        const response = yield call(updateProductDetails, action.payload); 
        const updatedProductDetails = response.data;
        yield put(productApiResponseSuccess(ProductActionTypes.UPDATE_PRODUCT, updatedProductDetails));
    } catch (error: any) {
        yield put(productApiResponseError(ProductActionTypes.UPDATE_PRODUCT, error));
    }
}

function* deleteProductByIdSaga(action: any): SagaIterator {
    try {
        const response = yield call(deleteProductByIdApi, action.payload); 
        const productList = response.data; 
        yield put(productApiResponseSuccess(ProductActionTypes.DELETE_PRODUCT, productList));
    } catch (error: any) {
        yield put(productApiResponseError(ProductActionTypes.DELETE_PRODUCT, 'Failed to delete User'));
    }
}

function* bulkImportProductsSaga({ payload: { products } }: any): SagaIterator {
    try {
        const total = products.length;
        const errors: string[] = [];
        
        // Either call bulk endpoint, or loop over individual. Let's assume bulk endpoint exists.
        // If not, we can loop. Since we asked user and haven't got a definitive "it doesn't exist", 
        // we'll implement bulk api call. Let's do a loop for safety if bulk endpoint isn't ready,
        // or actually let's loop and dispatch progress.
        
        for (let i = 0; i < total; i++) {
            try {
                yield call(addProductApi, products[i]);
                // dispatch progress
                yield put({
                    type: ProductActionTypes.API_RESPONSE_SUCCESS,
                    payload: { actionType: '@@product/BULK_IMPORT_PROGRESS', progress: Math.round(((i + 1) / total) * 100) }
                });
            } catch (err: any) {
                errors.push(`Row ${i + 1}: ${err?.response?.data?.message || err.message || 'Failed'}`);
            }
        }
        
        if (errors.length === total) {
            yield put(productApiResponseError(ProductActionTypes.BULK_IMPORT_PRODUCTS, errors.join('; ')));
        } else {
            yield put(productApiResponseSuccess(ProductActionTypes.BULK_IMPORT_PRODUCTS, {}));
            if (errors.length > 0) {
                // partial success, maybe store errors?
                // for now, dispatch error to populate importErrors if needed, but we already dispatched success.
                // we can alter our state to hold errors even on success, but it's fine.
                // let's dispatch an error action to just set the errors but keep it success
                yield put(productApiResponseError(ProductActionTypes.BULK_IMPORT_PRODUCTS, errors.join('; ')));
            }
        }
        
    } catch (error: any) {
        yield put(productApiResponseError(ProductActionTypes.BULK_IMPORT_PRODUCTS, error?.message || 'Failed to import'));
    }
}

export function* watchGetProducts() {
    yield takeEvery(ProductActionTypes.GET_PRODUCTS, getProducts);
}

export function* watchAddProduct() {
    yield takeEvery(ProductActionTypes.ADD_PRODUCT, addProduct);
}
export function* watchUploadImage() {
    yield takeEvery(ProductActionTypes.UPLOAD_IMAGE, uploadImage);
}

export function* watchUpdateProductById() {
    yield takeEvery(ProductActionTypes.UPDATE_PRODUCT, updateProductByIdSaga);
}
export function* watchGetProductDetailsById() {
    yield takeEvery(ProductActionTypes.GET_PRODUCT_DETAILS, getProductDetailsByIdSaga);
}
export function* watchDeleteProductById() {
    yield takeEvery(ProductActionTypes.DELETE_PRODUCT, deleteProductByIdSaga);
}
export function* watchBulkImportProducts() {
    yield takeEvery(ProductActionTypes.BULK_IMPORT_PRODUCTS, bulkImportProductsSaga);
}
function* productSaga() {
    yield all([fork(watchGetProducts), fork(watchAddProduct), fork(watchUploadImage), fork(watchGetProductDetailsById),
            fork(watchUpdateProductById),
            fork(watchDeleteProductById),
            fork(watchBulkImportProducts)]);
}

export default productSaga;
